import cn from 'classnames';
import React from 'react';
import { ErrorHint } from '../../../../../components/ErrorHint';
import Markdown from '../../../../../components/Markdown';
import { inIframe } from '../../../../../utils/location';
import { ContentWrapper } from '../../ContentWrapper';
import { useMatrixContext } from '../MatrixWrapper';
import styles from './MatrixTitle.module.css';

interface MatrixTitleProps {
  title: string | undefined;
  errorMessage: string | undefined;
}

export const MatrixTitle: React.FC<MatrixTitleProps> = ({ title, errorMessage }) => {
  const { viewMode } = useMatrixContext();

  if (!title && !errorMessage) {
    return null;
  }

  if (viewMode === 'default') {
    return (
      <div className={styles.defaultContainer}>
        {title && <Markdown className={styles.defaultTitle}>{title}</Markdown>}

        {errorMessage && <ErrorHint className={cn({ [c(styles.withTitle)]: !!title })}>{errorMessage}</ErrorHint>}
      </div>
    );
  }

  return (
    <ContentWrapper
      borders="top"
      className={styles.compactContainer}
      {...(!title && { style: { paddingTop: 'var(--spacing-xs)', paddingBottom: 'var(--spacing-xs)' } })}
    >
      <div className={cn({ [c(styles.withSpacing)]: inIframe() })}>
        {title && <Markdown className={styles.compactTitle}>{title}</Markdown>}

        {errorMessage && <ErrorHint className={cn({ [c(styles.withTitle)]: !!title })}>{errorMessage}</ErrorHint>}
      </div>
    </ContentWrapper>
  );
};
